import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Flex } from 'onefaceui-react-components';
import { v4 as uuid } from 'uuid';

import { getResourceTo, replaceSizeAlias } from "react/utils/utils";

const sizeKeys = [
  'actualSize1',
  'actualSize2',
  'actualSize3',
  'plannedSize1',
  'plannedSize2',
  'plannedSize3',
  'actualPickupSize1',
  'actualPickupSize2',
  'actualPickupSize3',
  'plannedPickupSize1',
  'plannedPickupSize2',
  'plannedPickupSize3',
  'damagedSize1',
  'damagedSize2',
  'damagedSize3'
];

const formatSizes = (sizes) => {
  return sizeKeys.reduce((acc, curr) => {
    if (acc.has(curr)) {
      acc = acc.set(curr, new Monet.Format.DECIMAL(acc.get(curr)).format().getValue());
    }
    return acc;
  }, Map(sizes));
};

const Sizes = ({ stop }) => {
  const sizes = formatSizes(stop.get('sizes'));
  const children = sizeKeys.map((key, i) => {
    if (sizes.has(key)) {
      return (
        <Flex
          key={uuid()}
          justifyContent="space-between"
          alignItems="center"
          className="sizes-item"
        >
          <div>{replaceSizeAlias(getResourceTo(`Stop.popup.${key}`))}</div>
          <div>{sizes.get(key, '')}</div>
        </Flex>
      );
    }
  });
  return (
    <Fragment>
      {children}
    </Fragment>
  );
}

Sizes.propTypes = {
  routeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  stop: PropTypes.object.isRequired
}

export default Sizes;
